import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import {
  AuthenticationService,
  EquipmentService,
} from 'src/app/core/providers';
import { ProfileService } from 'src/app/core/providers/services/profile.service';

@Component({
  selector: 'app-product-sort',
  templateUrl: './product-sort.component.html',
  styleUrls: ['./product-sort.component.scss'],
  standalone: false,
})
export class ProductSortComponent implements OnInit {
  clientId: number;
  scrollContentClass: string = 'scroll-content';
  constructor(
    public profileService: ProfileService,
    public authenticationService: AuthenticationService,
    public equipmentService: EquipmentService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.authenticationService.startSentryTransaction(
      this.router.routerState.snapshot.url
    );
    this.clientId =
      this.authenticationService.userInfoView.SelectedClient.ClientID;
    this.authenticationService.finishSentryTransaction();
  }

  ngOnDestroy() {
    this.equipmentService.clearCache();
  }
}
